import React, { PureComponent } from 'react'
import { Jumbotron } from 'reactstrap'

class NaoAutorizado extends PureComponent {    
    render() {
        return (
            <div className="container">
                <Jumbotron>
                    <h1>Não Autorizado</h1>
                    <p>Seu usuário não tem permisão para acessar o recurso requisitado.</p>
                </Jumbotron>

            </div>
        )
    }
}

export default NaoAutorizado
